export default __webpack_public_path__ + "static/media/bn.bdafbb2a.svg";